import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardAppSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_Dashboard_ParticipantDashboardResponseDto,
} from '../../services/wealthlane-award-services';
import { useSelector } from 'react-redux';
import { selectTenantId } from '../../pages/configuration/participantSignupSlice';

const useGetAwardParticipantDashboardDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_Dashboard_ParticipantDashboardResponseDto | undefined,
  unknown
> => {
  const tenantId = useSelector(selectTenantId);

  const awardParticipantDashboardDetails = useQuery(
    ['getAwardParticipantDashboardDetails'],
    async () => {
      if (tenantId) {
        return await handleRequest(
          DashboardAppSharedService.getApiAwardApiAppDashboardParticipantDashboard()
        );
      }
    }
  );

  return awardParticipantDashboardDetails;
};

export default useGetAwardParticipantDashboardDetails;
